import { Routes } from '@angular/router';
import { AccessDeniedPageComponent } from './access-denied-page';

import { ErrorComponent } from './error.component';
import { InternalSeverErrorPageComponent } from './internal-sever-error-page';
import { MaintenancePageComponent } from './maintenance-page';
import { NotFoundPageComponent } from './not-found-page';

export const errorRoutes: Routes = [
  {
    path: 'error',
    component: ErrorComponent,
    data: {
      authorities: [],
      pageTitle: 'error.title',
      errorTitle: 'error.title',
      errorMessage: '',
    },
  },
  {
    path: 'accessdenied',
    component: AccessDeniedPageComponent,
    data: {
      authorities: [],
      pageTitle: 'ERROR.HTTP.403.TITLE',
      errorTitle: 'ERROR.HTTP.403.TITLE',
      errorMessage: 'ERROR.HTTP.403.MESSAGE',
    },
  },
  {
    path: '403',
    component: AccessDeniedPageComponent,
    data: {
      authorities: [],
      pageTitle: 'ERROR.HTTP.403.TITLE',
      errorTitle: 'ERROR.HTTP.403.TITLE',
      errorMessage: 'ERROR.HTTP.403.MESSAGE',
    },
  },
  {
    path: '404',
    component: NotFoundPageComponent,
    data: {
      authorities: [],
      pageTitle: 'ERROR.HTTP.404.TITLE',
      errorTitle: 'ERROR.HTTP.404.TITLE',
      errorMessage: 'ERROR.HTTP.404.MESSAGE',
    },
  },
  {
    path: '500',
    component: InternalSeverErrorPageComponent,
    data: {
      authorities: [],
      pageTitle: 'ERROR.HTTP.500.TITLE',
      errorTitle: 'ERROR.HTTP.500.TITLE',
      errorMessage: '',
    },
  },
  {
    path: 'maintenance',
    component: MaintenancePageComponent,
    data: {
      authorities: [],
      pageTitle: 'ERROR.HTTP.MAINTENANCE.TITLE',
      errorTitle: 'ERROR.HTTP.MAINTENANCE.TITLE',
      errorMessage: 'ERROR.HTTP.MAINTENANCE.MESSAGE',
    },
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
